import _ from 'lodash';
import { getBaseIndeedURL, getBaseMsgsUrl, getStagingEnvironment } from '../browser-store';
import { isInstance, isStagingEnvironment, isUserAgentMobile } from '../browser-store/utils/env';
import { StagingLevel } from '../enums/StagingLevel';

const MOBILE_VIEWJOB_PATH = 'm/viewjob';
const DESKTOP_VIEWJOB_PATH = 'rc/clk';
// rc/clk url path doesn't work in qae2e, so use /viewjob url. Don't use /viewjob in PROD because we won't have job click
// logging
const QAE2E_DESKTOP_VIEWJOB_PATH = 'viewjob';
const MESSAGING_SOURCE = 'msg';
const MESSAGING_VJS = '3'; // always show vj instead of 3rd party

const CONVERSATIONS = 'messaging/jobseekers/v2/conversations';

export const getViewJobUrl = (jobKey: string, from?: string) => {
    let viewJobPath: string;
    if (isUserAgentMobile()) {
        viewJobPath = MOBILE_VIEWJOB_PATH;
    } else {
        if (isInstance('qae2e') && isStagingEnvironment(StagingLevel.QA)) {
            viewJobPath = QAE2E_DESKTOP_VIEWJOB_PATH;
        } else {
            viewJobPath = DESKTOP_VIEWJOB_PATH;
        }
    }

    const urlParams = new URLSearchParams();
    urlParams.set('jk', jobKey);
    urlParams.set('from', from || MESSAGING_SOURCE);
    urlParams.set('vjs', MESSAGING_VJS);

    return `${getBaseIndeedURL()}/${viewJobPath}?${urlParams.toString()}`;
};

export const getCompanyPageUrl = (relativeCompanyPageUrl: string) => {
    if (_.isEmpty(relativeCompanyPageUrl)) {
        return '';
    } else {
        const urlParams = new URLSearchParams();
        urlParams.set('from', MESSAGING_SOURCE);

        return `${getBaseIndeedURL()}${relativeCompanyPageUrl}?${urlParams.toString()}`;
    }
};

export const getFileDownloadUrl = (convsId: string, eventId: string, contentHash: string) => {
    const msgsBase = getBaseMsgsUrl();
    return `${msgsBase}/${CONVERSATIONS}/${convsId}/messages/${eventId}/files/${contentHash}?ims=1`;
};

export const getFileDownloadUrlIms = () => {
    const msgsBase = getBaseMsgsUrl();
    return `${msgsBase}/${CONVERSATIONS}/convsId/messages/eventId/files/fileId?ims=1`;
};

// Apparently decodeURI does not decode "+" symbol but decodeURIComponent does.
// This matters for AccountMismatchNotice because the iae param from DREMR CTA can contain a "+" that is encoded as %2B
// But "+" can sometimes mean space which gets encoded as %20, which is why these two functions have different behavior
// You can read about this here: https://www.geeksforgeeks.org/how-to-encode-and-decode-a-url-in-javascript/
export const getUrlParam = (paramName: string) => {
    const results = new RegExp('[?&]' + paramName + '=([^&#]*)').exec(location.search);
    return results ? decodeURIComponent(results[1]) : undefined;
};

export const getLogoutUrl = (currentLocation: string) => {
    const stagingEnv = getStagingEnvironment();

    if (stagingEnv === StagingLevel.PRODUCTION) {
        return `https://secure.indeed.com/account/logout?continue=${currentLocation}`;
    } else {
        return `https://secure.qa.indeed.net/account/logout?continue=${currentLocation}`;
    }
};

export const getNotificationSettingsUrl = (
    currentLocation: string,
    language?: string,
    country?: string
) => {
    const stagingEnv = getStagingEnvironment();
    const baseNotificationsURL =
        stagingEnv === StagingLevel.PRODUCTION
            ? `https://secure.indeed.com/settings/notifications`
            : `https://secure.qa.indeed.net/settings/notifications`;
    const urlParams = new URLSearchParams();
    urlParams.set('from', currentLocation);
    if (language) {
        urlParams.set('hl', language);
    }
    if (country) {
        urlParams.set('co', country);
    }

    return `${baseNotificationsURL}?${urlParams.toString()}`;
};
